let toastContainer = null;

function getContainer() {
  if (toastContainer && document.body.contains(toastContainer)) return toastContainer;
  toastContainer = document.createElement("div");
  toastContainer.style.cssText =
    "position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:9999999;display:flex;flex-direction:column;align-items:center;gap:8px;pointer-events:none;";
  document.body.appendChild(toastContainer);
  return toastContainer;
}

const COLORS = {
  error: { bg: "#fff2f0", border: "#ffccc7", text: "#a8071a" },
  warning: { bg: "#fffbe6", border: "#ffe58f", text: "#ad6800" },
  info: { bg: "#e6f7ff", border: "#91d5ff", text: "#0050b3" },
  success: { bg: "#f6ffed", border: "#b7eb8f", text: "#389e0d" },
};

function show(type, content, duration = 3) {
  const c = COLORS[type] || COLORS.info;
  const el = document.createElement("div");
  el.style.cssText = `background:${c.bg};border:1px solid ${c.border};color:${c.text};padding:8px 16px;border-radius:6px;font-size:14px;box-shadow:0 2px 8px rgba(0,0,0,0.15);pointer-events:auto;transition:opacity 0.3s;`;
  el.textContent = content;
  getContainer().appendChild(el);
  setTimeout(() => {
    el.style.opacity = "0";
    setTimeout(() => el.remove(), 300);
  }, duration * 1000);
}

const toast = {
  error: (msg, dur) => show("error", msg, dur),
  warning: (msg, dur) => show("warning", msg, dur),
  info: (msg, dur) => show("info", msg, dur),
  success: (msg, dur) => show("success", msg, dur),
};

export default toast;
